/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._313842A17z%7Bmargin-top%3A-1px%7D%0A._0adFHsdnbC%7Bmargin-right%3A0%7D%0A._1DCdHiA17z%7Bmargin-bottom%3A-1px%7D%0A._2XsHFMdnbC%7Bmargin-left%3A0%7D%0A._0bjKvDzXzM%7Bborder-radius%3Avar(--ds-radius-small%2C3px)%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._3iDTPbvbI6%7Bdisplay%3Ainline-block%7D%0A._0KLXru9r67%7Bbackground-color%3Avar(--ds-border%2C%230b120e24)%7D%0A._1RrJLit2nV%7Bvertical-align%3Amiddle%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D%0A._2fwxA5DIqT%7Btext-align%3Acenter%7D");












import type { StrictXCSSProp } from '@atlaskit/css';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import type { EmojiImageRepresentation } from '../../types';
import { defaultEmojiHeight, defaultDenseEmojiHeight } from '../../util/constants';
import { emojiPlaceholderTestId } from './emojiPlaceholderTestId';
import { placeholder } from './styles';
const placeholderContainer = null;
export interface Props {
  loading?: boolean;
  representation?: EmojiImageRepresentation;
  shortName: string;
  showTooltip?: boolean;
  size?: number;
  xcss?: StrictXCSSProp<'backgroundColor', never>;
}
const EmojiPlaceholder = (props: Props): JSX.Element => {
  const {
    shortName,
    size = defaultEmojiHeight,
    showTooltip,
    representation,
    loading = false,
    xcss
  } = props;
  let scaledWidth;
  let scaledHeight;
  if (representation && size) {
    const width = representation.width;
    const height = representation.height;
    if (width && height) {
      scaledWidth = size / height * width;
      scaledHeight = size;
    }
  }
  const width: number = scaledWidth || size;
  const height: number = scaledHeight || size;
  const style = expValEquals('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? {
    fill: 'f7f7f7',
    minWidth: `${defaultDenseEmojiHeight}px`,
    minHeight: `${defaultDenseEmojiHeight}px`
  } : {
    fill: 'f7f7f7',
    minWidth: `${width}px`,
    width: `${width}px`,
    height: `${height}px`
  };
  return <span data-testid={emojiPlaceholderTestId(shortName)} aria-busy={loading} role="status" aria-label={shortName}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  className={ax(["_313842A17z _0adFHsdnbC _1DCdHiA17z _2XsHFMdnbC _0bjKvDzXzM _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbvbI6 _0KLXru9r67 _1RrJLit2nV _1ANEUSLRg7 _2fwxA5DIqT", [placeholder, xcss].join(' ')])}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
  style={style} title={showTooltip ? shortName : ''} />;
};
export default EmojiPlaceholder;

/**
 * @deprecated Use `import { emojiPlaceholderTestId } from '@atlaskit/emoji/emoji-placeholder'` instead.
 */
export { emojiPlaceholderTestId } from './emojiPlaceholderTestId';